import { GlobalProvider } from '../context/GlobalState';

// Components
import DeliveryOptions from './DeliveryOptions';

const DigitalCodeApp = props => {
	return (
		<GlobalProvider>
			<DeliveryOptions { ...props } />
		</GlobalProvider>
	);
};

export default DigitalCodeApp;
